import CardTemplate from "components/card/card-template/CardTemplate";
import { HoursOperation } from "components/hours-operation/HoursOperation";
import { MemberService } from "components/member-service/MemberService";
import React from "react";

const ReviewingApplicationCard = () => {
    // ========== Render ==========
    return (
        <CardTemplate title="We're Reviewing Your Application" className="text-base-content">
            <div className="font-medium text-base-content text-base flex flex-col gap-5">
                <p className="leading-6 text-base text-base-content font-medium" id="reviewing-application">
                    We're sorry, but your application requires further review, and we can't finish processing it at this time.
                    You do not yet have Guaranteed Issue Whole Life, but we have securely stored your information and noted it
                    for review. AAA Life will contact you once a decision is made.
                </p>

                <p className="leading-5 text-sm text-base-content font-medium pr-4">
                    If you have further questions or wish to learn about our other coverage options that may be available,
                    please contact our Member Service Advocates.
                </p>

                <MemberService titleClassName="text-black/90" />

                <HoursOperation className="text-black/90" />
            </div>
        </CardTemplate>
    );
};

export default ReviewingApplicationCard;
